/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Plan_Maxed_OutInputs */

const en_admin_membership_confirmations_plan_maxed_out = /** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have reached the member limit of your subscription.`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const de_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const es_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const fr_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const it_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const pl_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const hu_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/** @type {(inputs: Admin_Membership_Confirmations_Plan_Maxed_OutInputs) => LocalizedString} */
const ro_admin_membership_confirmations_plan_maxed_out = en_admin_membership_confirmations_plan_maxed_out;

/**
* | output |
* | --- |
* | "You have reached the member limit of your subscription." |
*
* @param {Admin_Membership_Confirmations_Plan_Maxed_OutInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_plan_maxed_out = /** @type {((inputs?: Admin_Membership_Confirmations_Plan_Maxed_OutInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Plan_Maxed_OutInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "de") return de_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "es") return es_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "it") return it_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_plan_maxed_out(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_plan_maxed_out(inputs)
	return ro_admin_membership_confirmations_plan_maxed_out(inputs)
});
export { admin_membership_confirmations_plan_maxed_out as "admin.membership_confirmations.plan_maxed_out" }